import { render, staticRenderFns } from "./stage-question.vue?vue&type=template&id=739fa796&scoped=true&"
import script from "./stage-question.vue?vue&type=script&lang=js&"
export * from "./stage-question.vue?vue&type=script&lang=js&"
import style0 from "./stage-question.vue?vue&type=style&index=0&id=739fa796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739fa796",
  null
  
)

export default component.exports